<template>
  <div class="px-4 pb-4">
    <table v-if="requests.length > 0" class="rev-request-table">
      <thead>
        <tr>
          <th>{{ $t('rev_requests.request') }}</th>
          <th>{{ $t('rev_requests.status') }}</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="req in requests" :key="req.id" @click="selectRequest(req)">
          <td>{{ req.title }}</td>
          <td>
            <div class="rev-request-status">
              <span :class="['rev-request-status-circle', `rev-request-status--${req.status}`]"
                >&nbsp;</span
              >
              {{ $t(`requests.statuses.${req.status}`) }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="loading" class="text-center mt-4">
      <t-spinner v-theme-font></t-spinner>
    </div>

    <div
      v-if="requests.length === 0 && !loading"
      class="flex flex-col items-center justify-center no-rev-requests"
    >
      <icon-notifications-off class="icon-no-rev-requests"></icon-notifications-off>
      <span class="mt-2">{{ $t('rev_requests.no_data') }}</span>
      <theme-button class="mt-2" @click="$emit('back')">{{
        $t('modal.back_to_chat')
      }}</theme-button>
    </div>

    <t-modal transition="slide-right" fullscreen :visible.sync="requestDetailModalVisible">
      <template #header>
        <button
          v-theme-font
          type="button"
          class="btn-back cursor-pointer"
          @click.prevent="requestDetailModalVisible = false"
        >
          <icon-back v-theme-fill class="icon-24"></icon-back>
          {{ $t('base.back_to_list') }}
        </button>
      </template>
      <request-show :request="selectedRequest" @refresh="fetchReservationRequests"></request-show>
    </t-modal>
  </div>
</template>

<script>
import IconBack from 'assets/icons/arrow-back.svg?inline'
import IconNotificationsOff from 'assets/icons/notifications-off.svg?inline'
import ThemeButton from 'javascript/Common/ThemeButton'
import RequestShow from './RequestShow'
import { UserReservations } from 'src/apis'

export default {
  name: 'RequestList',

  components: {
    RequestShow,
    ThemeButton,
    IconBack,
    IconNotificationsOff
  },

  data() {
    return {
      loading: false,
      selectedRequest: null,
      requestDetailModalVisible: false,
      requests: []
    }
  },

  created() {
    this.fetchReservationRequests()
  },

  methods: {
    fetchReservationRequests() {
      this.loading = true
      UserReservations.getReservations()
        .then((revRequests) => {
          this.requests = revRequests
        })
        .finally(() => {
          this.loading = false
        })
    },

    selectRequest(request) {
      this.selectedRequest = request
      this.requestDetailModalVisible = true
    }
  }
}
</script>
